import { createSlice } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'

export interface IAuthDynamicState {
    status: string
    data: any
    error: any
}

const initialState = {
    status: STATUS.IDLE,
    data: null,
    error: null
}

const authDynamic = createSlice({
    name: 'ui/auth-dynamic',
    initialState,
    reducers: {
        onRequest(state) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.error = action.payload
            if (state.data) {
                state.data.sub_domain = false
            }
        }
    }
})

export const authDynamicActions = authDynamic.actions
export default authDynamic.reducer
